import React from 'react';
import Icon from '@/v2/components/atoms/Icon';
import './RefreshIcon.scss';

const RefreshIcon = (props) => (
    <Icon iconName="RefreshIcon" {...props}>
        <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
            <g fill="none" fillRule="evenodd">
                <g fill="#FFF" fillRule="nonzero">
                    <g>
                        <g>
                            <path
                                d="M27.297 4.7C24.395 1.8 20.413 0 15.99 0 7.144 0 0 7.16 0 16s7.144 16 15.99
                                16c7.465 0 13.689-5.1 15.47-12h-4.163c-1.641 4.66-6.084 8-11.307
                                8-6.624 0-12.008-5.38-12.008-12S9.366 4 15.99 4c3.322 0 6.284 1.38 8.445 3.56L17.991 14H32V0l-4.703 4.7z"
                                className="RefreshIcon__plus"
                                transform="translate(-399 -663) translate(356.5 581) translate(42.5 82)"
                            />
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    </Icon>
);

export default RefreshIcon;
